import type { BoxProps } from '@chakra-ui/react';
import { HStack, Text } from '@chakra-ui/react';
import { Play, Soundbars } from '@time-line/components/icons';

interface MediaTagProps extends BoxProps {
  type: string;
  videoUrl?: string;
}

export function MediaTag({ type, videoUrl, ...props }: MediaTagProps) {
  let mediaType;

  if (type === 'timeline_podcast') {
    mediaType = 'Podcast';
  }
  if (videoUrl) {
    mediaType = 'Video';
  }

  if (!mediaType) {
    return null;
  }

  return (
    <HStack
      pos="absolute"
      left="xs"
      bottom="xs"
      bg="gray.50"
      borderRadius="full"
      py="4xs"
      pl="3xs"
      pr="2xs"
      spacing="4xs"
      {...props}
    >
      {mediaType === 'Video' && <Play boxSize="2xs" />}
      {mediaType === 'Podcast' && <Soundbars boxSize="2xs" />}
      <Text size="detail" fontWeight="medium">
        {mediaType}
      </Text>
    </HStack>
  );
}
